
import { Button, Card, CardContent } from "@material-ui/core";
import React, { Component } from "react";
import BarChartMengisiLengkap from "./components/mengisi-lengkap/BarChart";
import BarChartWilayah2 from "./components/mengisi-lengkap/BarChartWilayah";
import PieChartMengisiLengkap from "./components/mengisi-lengkap/PieChart";
import TableListPTMengisiLengkap from "./components/mengisi-lengkap/Table";
class DetailsTelahMengisiLengkap extends Component {
    render(){
      let userdata = JSON.parse(localStorage.getItem('sessiondata'));
      let access = userdata.i_idrole;
        return(
            <>
            <div className="row row-paddingless">
              <div className="col-md-12 text-right" style={{marginBottom:'20px'}}>
                <a href="/spmi/dashboard">
                  <Button className="btn btn-primary">
                    <i className="flaticon2-back"></i>
                    Kembali
                  </Button>
                </a>
              </div>
            </div>
            <Card>
              <CardContent>
                <div className="row row-paddingless">
                  <PieChartMengisiLengkap />
                  <div className="col-md-8 col-xxl-6" style={{textAlign:'center'}}>
                    <BarChartMengisiLengkap/>
                  </div>
                  
                  <div className="col-md-12 col-xxl-12" style={{textAlign:'center'}}>
                    {
                      access === "1" || access === 1 || access === "10" || access === 10 ?
                    <BarChartWilayah2 />
                    :""
                    }
                  </div>
                </div>
              </CardContent>
            </Card>
            <br/>
            <Card>
              <CardContent>
                <TableListPTMengisiLengkap />
              </CardContent>
            </Card>
            </>
        )
    }
}
export default DetailsTelahMengisiLengkap;